import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { includes } from 'lodash';
import PropTypes from 'prop-types';
import CardReaderView from './molecules/CardReaderView';
import { FULL_SCREEN_MODE_KEY } from './constants';
import { setFullScreenModeEnabled } from './redux/ui/actions';
import { HomeTexts, HomeRC } from './screens/Home/index';
import { ValueTicketRegionTexts, ValueTicketRegionRC } from './screens/ValueTicketRegion/index'; // prettier-ignore
import { ValueTicketPurchaseTexts, ValueTicketPurchaseRC } from './screens/ValueTicketPurchase/index'; // prettier-ignore
import { ValueTicketPassengersTexts, ValueTicketPassengersRC } from './screens/ValueTicketPassengers/index'; // prettier-ignore
import { ValueTicketConfirmationTexts, ValueTicketConfirmationRC } from './screens/ValueTicketConfirmation/index'; // prettier-ignore
import { ExtraTicketRegionTexts, ExtraTicketRegionRC } from './screens/ExtraTicketRegion/index'; // prettier-ignore
import { ExtraTicketPurchaseTexts, ExtraTicketPurchaseRC } from './screens/ExtraTicketPurchase/index'; // prettier-ignore
import { ExtraTicketPassengersTexts, ExtraTicketPassengersRC } from './screens/ExtraTicketPassengers/index'; // prettier-ignore
import { ExtraTicketConfirmationTexts, ExtraTicketConfirmationRC } from './screens/ExtraTicketConfirmation/index'; // prettier-ignore
import { SeasonalTicketRegionTexts, SeasonalTicketRegionRC } from './screens/SeasonalTicketRegion/index'; // prettier-ignore
import { SeasonalTicketConfirmationTexts, SeasonalTicketConfirmationRC } from './screens/SeasonalTicketConfirmation/index'; // prettier-ignore
import { AdditionalZoneRegionTexts, AdditionalZoneRegionRC } from './screens/AdditionalZoneRegion/index'; // prettier-ignore
import { AdditionalZonePurchaseTexts, AdditionalZonePurchaseRC } from './screens/AdditionalZonePurchase/index'; // prettier-ignore
import { AdditionalZonePassengersTexts, AdditionalZonePassengersRC } from './screens/AdditionalZonePassengers'; // prettier-ignore
import { AdditionalZoneConfirmationTexts, AdditionalZoneConfirmationRC } from './screens/AdditionalZoneConfirmation/index'; // prettier-ignore

const textColumnComponents = {
  HomeTexts,
  ValueTicketRegionTexts,
  ValueTicketPurchaseTexts,
  ValueTicketPassengersTexts,
  ValueTicketConfirmationTexts,
  ExtraTicketRegionTexts,
  ExtraTicketPurchaseTexts,
  ExtraTicketPassengersTexts,
  ExtraTicketConfirmationTexts,
  SeasonalTicketRegionTexts,
  SeasonalTicketConfirmationTexts,
  AdditionalZoneRegionTexts,
  AdditionalZonePurchaseTexts,
  AdditionalZonePassengersTexts,
  AdditionalZoneConfirmationTexts,
};

const readerColumnComponents = {
  HomeRC,
  ValueTicketRegionRC,
  ValueTicketPurchaseRC,
  ValueTicketPassengersRC,
  ValueTicketConfirmationRC,
  ExtraTicketRegionRC,
  ExtraTicketPurchaseRC,
  ExtraTicketPassengersRC,
  ExtraTicketConfirmationRC,
  SeasonalTicketRegionRC,
  SeasonalTicketConfirmationRC,
  AdditionalZoneRegionRC,
  AdditionalZonePurchaseRC,
  AdditionalZonePassengersRC,
  AdditionalZoneConfirmationRC,
};

const getTextColumnContent = (screen, t) => {
  const TextColumnContent = textColumnComponents[`${screen}Texts`];
  return <TextColumnContent t={t} />;
};

const getCardReaderContent = (screen, t) => {
  const ReaderColumnContent = readerColumnComponents[`${screen}RC`];
  return <ReaderColumnContent t={t} />;
};

class ScreenManager extends PureComponent {
  componentDidMount() {
    const shouldEnable = includes(window.location.search, FULL_SCREEN_MODE_KEY);
    this.props.setFullScreenModeEnabled(shouldEnable);
  }

  render() {
    const {
      screen,
      cardPosition,
      cardReaderZoomLevel,
      cardReaderCardLightActive,
      cardReaderGreenLightActive,
      isFullScreenModeEnabled,
      t,
    } = this.props;
    const textColumnContent = getTextColumnContent(screen, t);
    const cardReaderColumnContent = getCardReaderContent(screen, t);
    const isHomeScreen = screen === 'Home';
    return (
      <CardReaderView
        textColumnContent={textColumnContent}
        cardReaderColumnContent={cardReaderColumnContent}
        cardReaderZoomLevel={cardReaderZoomLevel}
        cardPosition={cardPosition}
        cardReaderGreenLightActive={cardReaderGreenLightActive}
        cardReaderCardLightActive={cardReaderCardLightActive}
        isFullScreenModeEnabled={isFullScreenModeEnabled}
        isHomeScreen={isHomeScreen}
      />
    );
  }
}

ScreenManager.propTypes = {
  screen: PropTypes.string.isRequired,
  cardPosition: PropTypes.number.isRequired,
  cardReaderZoomLevel: PropTypes.number.isRequired,
  cardReaderGreenLightActive: PropTypes.bool.isRequired,
  cardReaderCardLightActive: PropTypes.bool.isRequired,
  isFullScreenModeEnabled: PropTypes.bool.isRequired,
  setFullScreenModeEnabled: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

const mapStateToProps = ({ ui, cardReader }) => ({
  screen: ui.screen,
  cardReaderZoomLevel: ui.cardReaderZoomLevel,
  cardPosition: ui.cardPosition,
  cardReaderGreenLightActive: cardReader.greenLightActive,
  cardReaderCardLightActive: cardReader.cardLightActive,
  isFullScreenModeEnabled: ui.isFullScreenModeEnabled,
});

const mapDispatchToProps = (dispatch) => ({
  setFullScreenModeEnabled: (isEnabled) => dispatch(setFullScreenModeEnabled(isEnabled)), // eslint-disable-line
});

// prettier-ignore
export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(ScreenManager));
